export default __webpack_public_path__ + "static/media/credit-card-success.9f8c785d.png";